import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBalconyTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BalconyTagItem = ({ onDeleteClick, withNewTag }: IBalconyTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Есть балкон
    </TagComponent>
  );
};
